import CommonAPIService from "src/serviceHandlers/commonHandler";

class SchedulesService extends CommonAPIService {
  constructor(router) {
    super(router);
    this.baseUrl = "/api/schedules";
  }

  create(scheduleData) {
    return this.postCall(this.baseUrl, scheduleData);
  }

  list() {
    return this.getCall(this.baseUrl);
  }

  get(id) {
    return this.getCall(`${this.baseUrl}/${id}`);
  }

  update(id, scheduleData) {
    return this.putCall(`${this.baseUrl}/${id}`, scheduleData);
  }

  delete(id) {
    return this.deleteCall(`${this.baseUrl}/${id}`);
  }

  linkToClient(scheduleId, clientId) {
    return this.postCall(`${this.baseUrl}/${scheduleId}/clients/${clientId}`);
  }

  linkToCaregiver(scheduleId, caregiverId) {
    return this.postCall(`${this.baseUrl}/${scheduleId}/caregivers/${caregiverId}`);
  }

  unlinkFromClient(scheduleId, clientId) {
    return this.deleteCall(`${this.baseUrl}/${scheduleId}/clients/${clientId}`);
  }

  unlinkFromCaregiver(scheduleId, caregiverId) {
    return this.deleteCall(`${this.baseUrl}/${scheduleId}/caregivers/${caregiverId}`);
  }

  getByClient(clientId) {
    return this.getCall(`${this.baseUrl}/client/${clientId}`);
  }

  getByCaregiver(caregiverId, params = {}) {
    return this.getCall(`${this.baseUrl}/caregiver/${caregiverId}`, params);
  }

  assignCaregivers(scheduleId, caregiverIds) {
    return this.putCall(`${this.baseUrl}/${scheduleId}/assign-caregivers`, { caregiverIds });
  }

  getSchedulesByPeriod(params) {
    return this.getCall(`${this.baseUrl}/period`, params);
  }
}

export const schedulesService = new SchedulesService();
